import { Typography } from '../../../designComponents';
import {
  InfoRowStyled,
  VerticalSpaceStyled,
} from '../../../style/reusableStyle';
import { ViewProposalContainerStyled } from './style';

type Props = { notes?: string };
const TechnicalNote = (_props: Props) => {
  return (
    <ViewProposalContainerStyled>
      <Typography
        variant="normal"
        className="title-header"
        fontColor="secondary"
        strong
      >
        TECHNICIAN NOTE{' '}
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <div style={{ display: 'block' }}>
            <Typography style={{ marginBottom: '10px' }}>Notes :</Typography>
            <Typography className="value">
              {_props.notes ||
                'Lorem ipsum dolor sit amet consectetur. Mi ultricies mollis magna cursus libero. Lacus sodales gravida vulputate id suspendisse magna iaculis. Eget et et enim facilisi amet ac eget. Faucibus gravida risus massa aliquam vitae. Adipiscing pretium dignissim vestibulum non netus ultricies. Morbi sit sed sed vulputatepretium dolor dictum eget.'}
            </Typography>
          </div>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </ViewProposalContainerStyled>
  );
};

export default TechnicalNote;
